<template>
  <div class="login_dialog_warp" v-if="$store.state.app.login_dialog_isShow">
   <div class="login-container">
     <div class="login-form">
       <el-alert :title="$t('view_login_index_30')" show-icon type="warning" :closable="false" class="tips"></el-alert>
       <h5>{{$t('view_login_index_31')}}</h5>
       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" v-loading="loading">
         <el-form-item prop="loginName" label="">
           <el-input v-model="ruleForm.loginName" disabled @focus="clickLogin = false" @input="ruleForm.loginName = ruleForm.loginName.replace(/[\u4e00-\u9fa5]/g, '')" :placeholder="$t('view_login_index_32')"></el-input>
         </el-form-item>
         <el-form-item prop="password">
           <el-input size="small" v-model="ruleForm.password" maxlength="20" @focus="clickLogin = false" @keyup.enter.native="login" type="password" :placeholder="$t('view_login_index_33')"></el-input>
         </el-form-item>
         <el-form-item>
           <el-button size="small" type="primary" style="width: 100%;" @click="login" :disabled="buttonIsDisabled">{{$t('view_login_index_34')}}</el-button>
         </el-form-item>
       </el-form>
     </div>
   </div>
    <div class="x-dialog" v-if="xMessageDialog">{{$t('view_login_index_35')}} （{{time}}s）</div>
    <!--T云登录提示框-->
    <el-dialog :append-to-body="true" :title="$t('view_public_topbar_23')" :visible.sync="dialogVisible" width="30%" class="footerDialog">
      <p class="tc"><span><i class="el-icon-warning"></i>{{$t('view_login_index_36')}}</span></p>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">{{$t('view_login_index_37')}}</el-button>
      </span>
    </el-dialog>
    <!--账号已在代理商管理后台禁用-->
    <el-dialog :append-to-body="true" :title="$t('view_public_topbar_23')" :visible.sync="dialogAccountLimit" width="30%" class="footerDialog">
      <p class="tc"><span><i class="el-icon-warning"></i>{{$t('view_login_index_38')}}<i style="color: #409eff;">400-011-2158</i></span></p>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAccountLimit = false" size="small">{{$t('view_login_index_37')}}</el-button>
      </span>
    </el-dialog>
    <!--身份验证-->
    <el-dialog :append-to-body="true" :title="$t('view_login_index_39')" :visible.sync="dialogIdcard" width="600px" :close-on-click-modal="false" @close="resetForm('idcardForm')" class="footerDialog">
      <div style="padding-left: 50px;">
        <p>{{$t('view_login_index_40')}}</p>
        <el-form @submit.native.prevent :model="idcardForm" :rules="rules" ref="idcardForm" class="mt-20" label-width="80px">
          <el-form-item :label="$t('view_login_index_41')">
            <span>{{idcardForm.phone}}</span>
          </el-form-item>
          <el-form-item :label="$t('view_login_index_42')" prop="code">
            <el-input v-model="idcardForm.code" size="medium" :maxlength="5" style="width: 200px;"></el-input>
            <verification-button :key="ruleForm.loginName" @send="sendIdCode" :stop="secodeIdStop" ></verification-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="checkSecondValidPhoneSecode" style="width: 100px;" size="small">{{$t('view_public_topbar_24')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

import VerificationButton from '@/components/verificationButton/'
import Cookies from 'js-cookie'
import {
  loginConsole,
  nowCheckLogin,
  sendSecondValidPhoneSecode,
  checkSecondValidPhoneSecode
} from '@/api/app';
  export default {
    name: "login",
    data() {
      return {
        buttonIsDisabled: false,
        clickLogin: false, // 登录调接口请求失败时显示输入框红色
        clickPhoneLoginCode: false, // 登录调接口请求失败时显示输入框红色
        phoneLoginCodeErrorInfo: false, // 登录调接口请求失败时显示内容
        dialogAccountLimit: false,
        loading: false,
        dialogVisible: false,
        dialogIdcard: false,
        secodeIdStop: true,
        xMessageDialog: false,
        ruleForm: {
          loginName: Cookies.get('loginName_wm'),
          password: ''
        },
        idcardForm: {
          phone: '',
          code: ''
        },
        rules: {
          loginName: [{
            validator: this.loginNamePass,
            trigger: 'blur'
          }],
          password: [{
            validator: this.loginPasswordPass,
            trigger: 'blur'
          }],
          phone: [
            { validator: this.loginPhonePass, required: true, trigger: 'blur' }
          ],
          code: [
            { validator: this.loginCodePass, required: true, trigger: 'blur' },
            { min: 5, max: 5, message: i18n.t('view_login_index_43'), trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      VerificationButton
    },
    methods: {
      loginNamePass(rule, value, callback) {
        if (this.clickLogin) {
          callback(new Error(' '))
        } else {
          if (value === '') {
            callback(new Error(i18n.t('view_login_index_44')))
          } else {
            callback()
          }
        }
      },
      loginPasswordPass(rule, value, callback) {
        if (this.clickLogin) {
          callback(new Error(i18n.t('view_login_index_45')))
        } else {
          if (value === '') {
            callback(new Error(i18n.t('view_login_index_46')))
          } else {
            callback()
          }
        }
      },
      loginCodePass(rule, value, callback) {
        if (this.clickPhoneLoginCode) {
          callback(new Error(this.phoneLoginCodeErrorInfo))
        } else {
          if (value === '') {
            callback(new Error(i18n.t('view_login_index_47')))
          } else {
            callback()
          }
        }
      },
      loginPhonePass(rule, value, callback) {
        if (this.phoneNumberError) {
          callback(new Error(this.phoneLoginPhoneErrorInfo))
        }
        if (value === '' || value === undefined) {
          callback(new Error(i18n.t('view_login_index_48')))
        } else {
          const reg = /^1(1|2|3|4|5|6|7|8|9)\d{9}$/
          if (!reg.test(value)) { callback(new Error(i18n.t('view_login_index_49'))) } else {
            callback()
          }
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      sendIdCode() {
        this.secodeIdStop = true
        sendSecondValidPhoneSecode()
          .then(res => {
            if(res.code == 200) {
              this.secodeIdStop = false
            } else {
              alert(res.message)
            }
            console.log(555,res)
          })
          .catch(res => {
            this.secodeIdStop = true
            if (res.code === 210) {
              if (this.xMessageDialog) return
              this.xMessageDialog = true
              const timer = setInterval(() => {
                this.time--
                if (this.time === 0) {
                  this.time = 5
                  this.xMessageDialog = false
                  clearInterval(timer)
                }
              }, 1000)
            } else {
              alert(res.message)
            }
          })
      },
      checkSecondValidPhoneSecode() {
        const data = {
          secode: this.idcardForm.code
        }
        this.clickPhoneLoginCode = false
        this.$refs.idcardForm.validate(valid => {
          if (valid) {
            checkSecondValidPhoneSecode(data)
              .then(res => {
                if(res.code === 200) {
                  this.nowCheckLogin(res)
                  this.resetForm('idcardForm')
                } else {
                  alert(res.message)
                }
              })
              .catch(res => {
                if (res.code === 210) {
                  // 验证码有问题
                  this.clickPhoneLoginCode = true
                  this.phoneLoginCodeErrorInfo = res.message
                  this.$refs.idcardForm.validateField('code')
                } else {
                  alert(res.message)
                }
              })
          }
        })
      },
      login() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.loading = true
            loginConsole({
              loginName: this.ruleForm.loginName,
              password: this.ruleForm.password
            }).then(res => {
              if(res.code == 200) {
                this.nowCheckLogin(res)
              }
            }).catch((res) => {
              this.loading = false
              if (res.code === 206) {
                this.dialogIdcard = true
                this.idcardForm.phone = res.data
              } else if (res.code === 201) {
              this.dialogVisible = true
              } else if (res.code === 207) {
                this.dialogAccountLimit = true
              }  else {
                //this.jump()
                alert(res.message)
              }
            }).finally(() => {
              this.loading = false
            })
          } else {
            this.$message({
              type: 'error',
              message: i18n.t('view_login_index_50')
            })
            return false
          }
        })
      },
      nowCheckLogin(res) {
        const type = 1
        const token = res.data
        const login_name = Cookies.get('loginName_wm')
        const domain_id = Cookies.get('admin_domain_id_wm')
        const data = {
          type,
          token,
          login_name,
          domain_id
        }
        if (data.domain_id && data.login_name) {
          nowCheckLogin(data).then(res => {
            if (res.code == 200) {
              let infor = { domain:'.marketingforce.com',path:'/'}
              if (process.env.NODE_ENV === 'development') {
                infor = {domain:'localhost',path:'/'}
              }
              Cookies.set('admin_token_wm', res.data,infor)
              Cookies.set('X-Token', data.token,infor)
              this.$store.commit('app/set_login_dialog_isShow',false)
              this.$router.push('/index')
              window.location.reload();
            } else {
              this.jump()
              this.buttonIsDisabled = true
            }
          }).catch(err => {
            this.jump()
            this.buttonIsDisabled = true
          })
        } else {
          this.jump()
          this.buttonIsDisabled = true
        }
      },
      jump() {
        this.$confirm(i18n.t('view_login_index_51'), i18n.t('view_public_topbar_23'), {
          distinguishCancelAndClose: true,
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          location.href = process.env.BASE_Tyun_Domain + '/login/login'
          }).catch(action => {
          });
      }
    },
    mounted(){
      $('.login_dialog_warp').prependTo($("body"));
      if ($('.init_mongolia_layer').length > 0) {
        $('.init_mongolia_layer').remove();
      }
      $.myMongoliaClose();
    }
  }
</script>

<style lang="scss" rel='stylesheet/scss' scope>
  .mt-20{
  	margin-top: 20px;
  }
  .tips {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 15px;
  }
  .footerDialog{
    /deep/.el-dialog__footer{
      border: none;
    }
    /deep/.el-dialog__header{
      border: none;
    }
  }
  .login_dialog_warp {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    text-align: center;
    font-size: 0;
    white-space: nowrap;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 2001;
  }
  .login_dialog_warp:after {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
  }
  .login-container {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    font-size: 14px;
    white-space: normal;
    .login-form {
      background-color: #fff;
      width: 400px;
      height: 350px;
      padding: 25px;

      h5 {
        font-size: 16px;
        color: #797979;
        margin-bottom: 30px;
      }

      h6 {
        font-size: 12px;
        color: #797979;
        margin-bottom: 20px;
      }

      .el-form-item {

        &:nth-of-type(1),
        &:nth-of-type(2) {
          margin-bottom: 30px;
        }
      }

      .doing {
        text-align: right;

        span {
          margin-left: 15px;
          cursor: pointer;
          color: #797979;
        }
      }

      .erm {
        width: 150px;
      }

      .login-by {
        img {
          cursor: pointer;
          width: 30px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/login/index.vue